import { httpClient } from '@core/api';
import type { ApiSuccessResponse, PaginatedResult, PaginationMeta } from '@app-types/api.types';
import type { AxiosRequestConfig } from 'axios';

/**
 * Every Platform CRUD list endpoint (Users/Roles/Departments/Branches/
 * Hospitals/Lookup Types/Lookup Values/Audit Logs) returns the item
 * array directly as `data`, with pagination under the envelope's own
 * `meta.pagination` (`successResponse(result.items, {pagination: result.meta})`
 * — see e.g. department.controller.ts) — a different shape from Patient
 * Search's own `data: {items, meta}` nesting. This helper matches the
 * Platform convention specifically; do not reuse it for Patient/
 * Appointment/Clinical/Financial list endpoints without checking their
 * own controller shape first.
 */
export async function getPaginatedList<T>(url: string, config?: AxiosRequestConfig): Promise<PaginatedResult<T>> {
  const response = await httpClient.get<ApiSuccessResponse<T[]>>(url, config);
  const meta = (response.data.meta?.pagination as PaginationMeta | undefined) ?? {
    page: 1,
    limit: response.data.data.length,
    totalItems: response.data.data.length,
    totalPages: 1,
  };
  return { items: response.data.data, meta };
}
